/**
 * Read the `exp` claim of a JWT without verifying it (the server verifies; we
 * only need to know when OUR copy goes stale). Returns the expiry as epoch
 * milliseconds, or `undefined` for anything that is not a decodable JWT with
 * a numeric `exp`.
 */
export function getJwtExpiresAt(token: string | null | undefined): number | undefined {
  if (!token) {
    return undefined
  }

  const payload = token.split('.')[1]
  if (!payload) {
    return undefined
  }

  try {
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const exp: unknown = JSON.parse(json).exp
    return typeof exp === 'number' ? exp * 1000 : undefined
  } catch {
    return undefined
  }
}

/** True when the token has no readable expiry or expires within `withinMs`. */
export function isJwtExpiringWithin(token: string | null | undefined, withinMs: number): boolean {
  const expiresAt = getJwtExpiresAt(token)
  return expiresAt === undefined || expiresAt - Date.now() <= withinMs
}
